import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { GradientColorHeader } from "@Local/Components/Dialog/";
import { FutureOrderSectionByRead } from "./components";

const FutureDialog = props => {
	const { open = false, onClose = () => {}, sourceData = null } = props;

	return (
		<Dialog open={open} maxWidth="md" fullWidth>
			<GradientColorHeader onClose={onClose}>預計變更單</GradientColorHeader>
			<DialogContent>
				<FutureOrderSectionByRead 
					effectID={sourceData?.effectID}
					cycleOrderID={sourceData?.cycleOrderID}
					clubName={sourceData?.clubName}
				/>
			</DialogContent>
		</Dialog>
	);
};

FutureDialog.displayName = "FutureDialog";

export default FutureDialog;
